import colors, { paletteMap } from "./colors.js";

export default {
  background: paletteMap.inkGray["100"],
  paper: paletteMap.inkGray["50"],
  ui: {
    dark: {
      bold: paletteMap.inkGray["900"],
      moderate: paletteMap.inkGray["600"],  // 접근성 확보된 보조 텍스트
      subtle: paletteMap.inkGray["400"],    // 플레이스홀더, 서브틀한 요소
    },
  },
};
